import { Component } from "react";
import classNames from "classnames";

import Button from "../Buttons/Button";
import { buttonWithAuthorization } from "../buttonWithAuthorization";

// Using a class component to allow buttonWithAuthorization to bind a `ref` to
// the component
//
class CommentFormSubmit extends Component {
  render() {
    const { className, label, validateForm, onClick, isSubmitting } = this.props;

    const submitClassName = classNames(["btn", "btn-primary", className]);
    const onSubmitClick = e => {
      e.preventDefault();
      validateForm() && onClick(e);
    };

    return (
      <Button
        type="button"
        className={submitClassName}
        label={label}
        onClick={onSubmitClick}
        iconClassName="icon-arrow-right"
        iconPosition="after"
        data-loading={isSubmitting}
        disabled={isSubmitting}
        data-comment-validate-button
      />
    );
  }
}

export default buttonWithAuthorization(CommentFormSubmit);
